import DOMPurify from 'dompurify';

/**
 * Converts a subset of markdown to sanitized HTML.
 * Supports: headings, bold, italic, inline code, code blocks, ordered/unordered lists, line breaks.
 */
export function markdownToHtml(text: string): string {
  let html = text
    // Code blocks (``` ... ```)
    .replace(/```[\w]*\n?([\s\S]*?)```/g, '<pre><code>$1</code></pre>')
    // Inline code
    .replace(/`([^`]+)`/g, '<code>$1</code>')
    // Headings
    .replace(/^### (.+)$/gm, '<h3>$1</h3>')
    .replace(/^## (.+)$/gm, '<h2>$1</h2>')
    .replace(/^# (.+)$/gm, '<h1>$1</h1>')
    // Bold + italic
    .replace(/\*\*\*(.+?)\*\*\*/g, '<strong><em>$1</em></strong>')
    // Bold
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    // Italic
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
    // Unordered lists: lines starting with "- " or "* "
    .replace(/^[*-] (.+)$/gm, '<li>$1</li>')
    // Ordered lists: lines starting with "1. " etc.
    .replace(/^\d+\. (.+)$/gm, '<li>$1</li>');

  // Wrap consecutive <li> items in <ul>
  html = html.replace(/(<li>.*<\/li>\n?)+/g, (match) => `<ul>${match}</ul>`);

  // Paragraphs: double newlines
  html = html
    .split(/\n{2,}/)
    .map((block) => {
      if (/^<(h[1-3]|ul|pre|li)/.test(block.trim())) return block;
      const inner = block.replace(/\n/g, '<br/>');
      return `<p>${inner}</p>`;
    })
    .join('\n');

  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'code', 'pre', 'ul', 'ol', 'li', 'h1', 'h2', 'h3'],
    ALLOWED_ATTR: [],
  });
}
